import { render } from "./KundenantragList.vue?vue&type=template&id=0b8ec183"
import script from "./KundenantragList.vue?vue&type=script&setup=true&lang=js"
export * from "./KundenantragList.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/KundenantragList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b8ec183"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b8ec183', __exports__)) {
    api.reload('0b8ec183', __exports__)
  }
  
  module.hot.accept("./KundenantragList.vue?vue&type=template&id=0b8ec183", () => {
    api.rerender('0b8ec183', render)
  })

}


export default __exports__